import Vue from 'vue';
import VueRouter from 'vue-router';
import layout from '@/views/Layout/Layout.vue';
import Index from '../views/Home/index.vue';
import sys from '@/config';
import { judgeLogin, goLogin } from '@/utils/judge'
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location)
    .catch((err) => err);
}; // 重复点击路由
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'index',
    component: layout,
    children: [
      {
        path: '/',
        name: 'index',
        meta: {
          title: '首页',
        },
        component: Index,
      },

    ],
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: () => import('@/views/UserCenter/UserCenter.vue'),
  },
  {
    path: "/visitsStatisticsReport",
    name: "visitsStatisticsReport",
    component: () => import("@/views/visitsStatisticsReport/index"),
    meta: {
      title: "访问量报表",
    },
  },
  {
    path: '/*',
    redirect: '/',
  }
];

const router = new VueRouter({
  base: sys.publicPath,
  mode: 'history',
  routes,
});
router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV !== 'development') {
    if (to.path === '/visitsStatisticsReport') {
      if (!judgeLogin()) {
        goLogin()
        return
      }
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}')
      const hasBarometer = (userInfo.baseRoleList || []).find(item=>item.roleCode === 'barometer')
      // if (['00950675', '00053316','01452147', '01499303', '01508387'].includes(userInfo.jobNumber)) {
      //   next()
      // }else {
      //   next('/')
      // }
      if (hasBarometer) {
        next()
      }else {
        next('/')
      }
    }
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
export default router;
